Namespace 'Customer.Reports'

class Customer.Reports.OperatorAvailabilityReportMetrics
  constructor: ->
    klass = Customer.Reports.OperatorAvailabilityReportMetric
    @currentlyAttended = new klass
      title: I18n.t('customer.reports.operator_availability.metrics.currently_attended')
    @unattended = new klass
      title: I18n.t('customer.reports.operator_availability.metrics.unattended')
    @withoutFirstResponse = new klass
      title: I18n.t('customer.reports.operator_availability.metrics.without_first_response')
    @pending = new klass
      title: I18n.t('customer.reports.operator_availability.metrics.pending')
    @scheduled = new klass
      title: I18n.t('customer.reports.operator_availability.metrics.scheduled')
    @inAttentionByBot = new klass
      title: I18n.t('customer.reports.operator_availability.metrics.in_attention_by_bot')
    @logged = new klass
      title: I18n.t('customer.reports.operator_availability.metrics.logged')
    @available = new klass
      title: I18n.t('customer.reports.operator_availability.metrics.available')
      className: 'available-metric'
    @inAttention = new klass
      title: I18n.t('customer.reports.operator_availability.metrics.in_attention')
      className: 'in-attention-metric'
    @paused = new klass
      title: I18n.t('customer.reports.operator_availability.metrics.paused')
      className: 'paused-metric'
    @offline = new klass
      title: I18n.t('customer.reports.operator_availability.metrics.offline')
      className: 'offline-metric'
    @outisdeCustomer = new klass
      title: I18n.t('customer.reports.operator_availability.metrics.outside_customer')
      className: 'in-attention-metric'

  reset: (metrics) ->
    @currentlyAttended.count = metrics.in_attention_count
    @outisdeCustomer.count = metrics.operators_outside_customer_count
    @unattended.count = metrics.pending_attention_ticket_count
    @withoutFirstResponse.count = metrics.with_no_first_response_count
    @pending.count = metrics.pending_client_tickets_count
    @scheduled.count = metrics.scheduled_tickets_count
    @inAttentionByBot.count = metrics.in_attention_by_bot_count
    @logged.count = metrics.logged_users_in_customer_count
    @available.count = metrics.available_operators_count
    @inAttention.count = metrics.operators_with_tickets_in_attention_count
    pausedTypes = []
    for title, count of metrics.paused_operators_count
      pausedTypes.push({title: title, count: count})
    @paused.setTypes(pausedTypes)
    offlineTypes = []
    for title, count of metrics.offline_operators_count
      offlineTypes.push({title: title, count: count})
    @offline.setTypes(offlineTypes)
